import { isSafari } from './isSafari';

// Handler to call on window resize for fixed header spacing

function runResize(){
    // Get alert height
    let alerts = document?.body?.querySelectorAll('[class*=Alert_container]');
    let tallestAlertHeight = 0;
            
    alerts?.forEach(function(alert) {
        if (alert?.getBoundingClientRect().height > tallestAlertHeight) {
            tallestAlertHeight = alert?.getBoundingClientRect().height;
        }
    });

    // Get header height
    let header = document.body.querySelector('#header');
    let headerHeight = header?.getBoundingClientRect().height;

    // Set top styles
    let main = document.body.querySelector('main');
    if (header) {
        // @ts-ignore
        header.style.top = `${tallestAlertHeight}px`;
    }
    if (main) {
        main.style.marginTop = `${headerHeight + tallestAlertHeight}px`;
    }
}

export function handleResizeFixedHeader() {
    if (isSafari) {
        // Timeout required for Safari bug...
        setTimeout(function() {
            runResize();
        }, 500);
    }
    else {
        runResize();
    }
}